import './styles/index.scss';
import { useStore } from '@/store/useStore';

export const GameSwitchOverlay = () => {
  const gameSwitchInProgress = useStore(
    (s) => s.gameWindowContext.gameSwitchInProgress,
  );

  if (!gameSwitchInProgress) {
    return null;
  }

  return (
    <div className="game-switch-overlay" data-testid="game-switch-overlay">
      <div className="game-switch-overlay__panel">
        <div className="game-switch-overlay__spinner" />
        <span className="game-switch-overlay__message">Loading next game…</span>
      </div>
    </div>
  );
};

export default GameSwitchOverlay;
